import axios from 'axios'

const BASE_URL = 'https://youtube-v31.p.rapidapi.com'
const options = {
  params: {
    maxResults: '50'
  },
  headers: {
    'X-RapidAPI-Key': '6852f2e907mshb775db7df91955ep1f2f1bjsn9eea34144575',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
  }
};

export const fatchFromApi = async (url) => {
    const { data } = await axios.get(`${BASE_URL}/${url}`, options)

    return data;
}

